document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('custom-contact-form');
    if (!form) return;
  
    var formUuid = form.getAttribute('data-form-uuid');
    var shopUuid = form.getAttribute('data-shop-uuid');
    var hasAttemptedSubmit = false;

    // Local@domain.tld — TLD must be at least 3 letters (e.g. .com; keeps error on incomplete .co while typing)
    var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{3,}$/;
    // Letters only (spaces, hyphen, apostrophe allowed) — no numbers
    var namePattern = /^[a-zA-Z]+(?:[a-zA-Z\s'-]*[a-zA-Z]+)?$/;

    var fields = {
      first_name: document.getElementById('ccf_first_name'),
      last_name: document.getElementById('ccf_last_name'),
      email: document.getElementById('ccf_email'),
      topic: document.getElementById('ccf_topic'),
      order_number: document.getElementById('ccf_order_number'),
      message: document.getElementById('ccf_message')
    };

    function clearError(fieldEl, errorId) {
      var errorEl = document.getElementById(errorId);
      if (errorEl) errorEl.textContent = '';
      fieldEl.classList.remove('ccf-invalid');
    }

    function setError(fieldEl, errorId, message) {
      document.getElementById(errorId).textContent = message;
      fieldEl.classList.add('ccf-invalid');
    }

    function isEmailValid(value) {
      return emailPattern.test(value);
    }

    function isNameValid(value) {
      return namePattern.test(value);
    }

    function getNameError(value, label) {
      if (!value) return label + ' is required';
      if (!isNameValid(value)) return label + ' cannot contain numbers or special characters';
      return '';
    }

    function getEmailError(value) {
      if (!value) return 'Email is required';
      if (!isEmailValid(value)) return 'Please enter a valid email';
      return '';
    }

    function validateFieldLive(fieldEl, errorId, getError) {
      if (!hasAttemptedSubmit) return;
      var err = getError();
      if (err) setError(fieldEl, errorId, err);
      else clearError(fieldEl, errorId);
    }

    // After first Send, update errors live — clear only when value is valid
    fields.first_name.addEventListener('input', function () {
      validateFieldLive(fields.first_name, 'ccf_err_first_name', function () {
        return getNameError(fields.first_name.value.trim(), 'First Name');
      });
    });
    fields.last_name.addEventListener('input', function () {
      validateFieldLive(fields.last_name, 'ccf_err_last_name', function () {
        return getNameError(fields.last_name.value.trim(), 'Last Name');
      });
    });
    fields.email.addEventListener('input', function () {
      validateFieldLive(fields.email, 'ccf_err_email', function () {
        return getEmailError(fields.email.value.trim());
      });
    });
    fields.message.addEventListener('input', function () {
      validateFieldLive(fields.message, 'ccf_err_message', function () {
        return fields.message.value.trim() ? '' : 'Message is required';
      });
    });
  
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hasAttemptedSubmit = true;
  
      document.querySelectorAll('.ccf-error').forEach(function (el) { el.textContent = ''; });
      document.querySelectorAll('.ccf-invalid').forEach(function (el) { el.classList.remove('ccf-invalid'); });
  
      var isValid = true;
  
      var firstName = fields.first_name.value.trim();
      var lastName = fields.last_name.value.trim();
      var email = fields.email.value.trim();
      var message = fields.message.value.trim();
  
      var firstNameErr = getNameError(firstName, 'First Name');
      if (firstNameErr) {
        setError(fields.first_name, 'ccf_err_first_name', firstNameErr);
        isValid = false;
      }

      var lastNameErr = getNameError(lastName, 'Last Name');
      if (lastNameErr) {
        setError(fields.last_name, 'ccf_err_last_name', lastNameErr);
        isValid = false;
      }
  
      var emailErr = getEmailError(email);
      if (emailErr) {
        setError(fields.email, 'ccf_err_email', emailErr);
        isValid = false;
      }
  
      if (!message) {
        setError(fields.message, 'ccf_err_message', 'Message is required');
        isValid = false;
      }
  
      if (!isValid) return;
  
      var submitBtn = document.getElementById('ccf_submit_btn');
      submitBtn.disabled = true;
      submitBtn.textContent = 'SENDING...';
  
      var formResponseObj = {
        'First Name': firstName,
        'Last Name': lastName,
        'Email': email,
        'Topic': fields.topic.value,
        'Order number': fields.order_number.value.trim(),
        'Message': message
      };
  
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('X-Shop-Uuid', shopUuid);
  
      var payload = JSON.stringify({
        form_uuid: formUuid,
        formResponse: JSON.stringify(formResponseObj),
        confirmationMail: true,
        email_check: email,
        utm_params: '{}',
        referrer_url: window.location.href
      });
  
      fetch('https://formbuilder.hulkapps.com/ajaxcall/formresponse', {
        method: 'POST',
        headers: myHeaders,
        body: payload,
        redirect: 'follow'
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          form.reset();
          document.querySelectorAll('.ccf-field, .ccf-submit-wrap').forEach(function (el) {
            el.style.display = 'none';
          });
          document.getElementById('ccf_success_msg').style.display = 'block';
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'SEND';
          alert('Something went wrong. Please try again.');
          console.error('Form submit error:', err);
        });
    });
  });
